import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

// mds icons are dynamically imported from the assets folder
// MdsConfig.iconsDynamicImportPath = `/${currentLocale}/assets/`;
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
